module.exports = __webpack_public_path__ + "static/media/bs_age_groups.73876c62.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bs_age_groups.png
// module id = 627
// module chunks = 0 1 2